module.exports = __webpack_public_path__ + "img/star2-new-end.ea7c90fc.svg";